// extracted by mini-css-extract-plugin
module.exports = {"values":"Autocomplete_values__1qLbl","suggestions":"Autocomplete_suggestions__6oJ24"};